import Vue from 'vue'
import formTools from './q-form-generator'
import qList from './q-list'
import selector from './q-selector'
import qTree from './q-tree'


Vue.component('q-form-generator', formTools.fromGenerator);
Vue.component('q-element-generator', formTools.elementGenerator);
Vue.component('q-form-designer', formTools.fromDesigner);
Vue.component('q-composite-list', qList.compositeList);
Vue.component('q-item-selector', selector.itemSelector);
Vue.component('q-enum-selector', selector.enumSelector);
Vue.component('q-model-selector', selector.modelSelector);
Vue.component('q-parameter-selector', selector.parameterSelector);
Vue.component('q-model-tree', qTree.modelTree);